export enum InvoiceStepFilterEnum {
    CURRENT_INVOICE = "CURRENT_INVOICE",
    PREVIOUS_INVOICE = "PREVIOUS_INVOICE",
    DATES_INVOICE = "DATES_INVOICE"
}